export default __webpack_public_path__ + "static/media/banner-sale.b6fc4509.png";